// URLS
import { getV2SCSSUrl } from "../../urls/map-view/SecURL";

// Constants and utils
import { sendGetRequest } from "../../utils/api/apiUtils";
import {
  CitiesBBox,
  CitiesRestaurantsData,
} from "../../constants/CitiesRestaurantsData";

// sdk
import AtlasClient from "../../sdk/AtlasClient";

export async function getSecInfo(cityBBox) {
  // checking to hardcoded data or not
  const isShowCityHardCodedData = Object.values(CitiesBBox).includes(cityBBox);

  // if matches return hardcoded data
  if (isShowCityHardCodedData) {
    const response = CitiesRestaurantsData[cityBBox];

    // 5 sec delay
    await new Promise((resolve) => setTimeout(resolve, 5000));

    // response return
    return response;
  }

  // call the api
  const bbox = cityBBox.split(",");

  const nw = `${bbox[3]},${bbox[2]}`;
  const se = `${bbox[1]},${bbox[0]}`;

  // const params = {
  //   nw: bbox[1].concat(",", bbox[0]),
  //   se: bbox[3].concat(",", bbox[2]),
  // };
  // return sendGetRequest(getV2SCSSUrl, params);

  // calling api with type for SEC
  const callWithTypeString = true;

  const response = await AtlasClient.heatmapGeoWithinBBox(
    nw,
    se,
    "restaurant",
    callWithTypeString
  );
  return response;
}
